var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useCallback, useMemo, useState } from "react";
import { Editor, TextArea } from "@folio/stripes/components";
import styles from "./RichTextEditor.module.css";
export var MINIMAL_TOOLBAR = [
    ["bold", "italic", "underline"],
    [{ list: "ordered" }, { list: "bullet" }],
    ["link", "clean"],
];
export var DEFAULT_FORMATS = [
    "bold",
    "italic",
    "underline",
    "list",
    "bullet",
    "link",
];
export var RichTextEditor = function (_a) {
    var value = _a.value, onChange = _a.onChange, label = _a.label, required = _a.required, disabled = _a.disabled, error = _a.error, id = _a.id, toolbar = _a.toolbar, formats = _a.formats;
    var _b = useState(false), showSource = _b[0], setShowSource = _b[1];
    var resolvedToolbar = toolbar === undefined ? MINIMAL_TOOLBAR : toolbar;
    var resolvedFormats = formats !== null && formats !== void 0 ? formats : DEFAULT_FORMATS;
    var modules = useMemo(function () {
        if (resolvedToolbar === false) {
            return { toolbar: false };
        }
        var container = Array.isArray(resolvedToolbar)
            ? resolvedToolbar
            : resolvedToolbar.container;
        return {
            toolbar: {
                container: __spreadArray(__spreadArray([], container, true), [["source"]], false),
                handlers: {
                    source: function () { return setShowSource(function (s) { return !s; }); },
                },
            },
        };
    }, [resolvedToolbar]);
    var handleSourceChange = useCallback(function (e) {
        return onChange(e.target.value, "user");
    }, [onChange]);
    var handleEditorChange = useCallback(function (html, _delta, source) {
        return onChange(html, source === "user" ? "user" : "api");
    }, [onChange]);
    var ariaLabel = typeof label === "string" ? label : undefined;
    var wrapperClass = showSource
        ? "".concat(styles.wrapper, " ").concat(styles.sourceMode)
        : styles.wrapper;
    return (React.createElement("div", { className: wrapperClass },
        React.createElement(Editor, { id: id, label: label, required: required, readOnly: disabled, value: value, onChange: handleEditorChange, modules: modules, formats: resolvedFormats, error: showSource ? undefined : error }),
        showSource ? (React.createElement(React.Fragment, null,
            React.createElement(TextArea, { value: value, onChange: handleSourceChange, disabled: disabled, fullWidth: true, marginBottom0: true, rootClass: styles.sourceRoot, "aria-label": ariaLabel, "data-testid": "rich-text-source-textarea" }),
            error ? (React.createElement("div", { role: "alert", className: styles.error }, error)) : null)) : null));
};
